import { render, staticRenderFns } from "./PasswordNew.vue?vue&type=template&id=4f22b1ab"
import script from "./PasswordNew.vue?vue&type=script&lang=js"
export * from "./PasswordNew.vue?vue&type=script&lang=js"
import style0 from "./PasswordNew.vue?vue&type=style&index=0&id=4f22b1ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports